var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"not-found"},[_vm._v("404")])
}
var staticRenderFns = []

export { render, staticRenderFns }